import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=be07ef10&"
import script from "./trainDetail.vue?vue&type=script&lang=ts&"
export * from "./trainDetail.vue?vue&type=script&lang=ts&"
import style0 from "./trainDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports